module.exports = __webpack_public_path__ + "img/morcode.e2cfa57e.png";